import { get, post } from '../index';

export const migrateDb = () => {
  return post('admin/db');
};

export const getArtifactVersions = (url) => {
  return get(`admin/artifact-versions`);
};